export default __webpack_public_path__ + "static/media/ru-ba.592c1487.svg";